import Text, { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import type { BasicCheckboxProps } from './basic';
import { BASIC_CHECKBOX_SIZE, BasicCheckbox } from './basic';
import { ErrorMessage } from './styled';

export type { BasicCheckboxProps };

export { BASIC_CHECKBOX_SIZE, BasicCheckbox };

export type CheckboxProps = Omit<BasicCheckboxProps, 'error' | 'size'> & {
    errorMessage?: string;
};

export const Checkbox: FC<CheckboxProps> = (props) => {
    const { errorMessage, ...rest } = props;
    const error = errorMessage !== undefined && errorMessage !== '';

    return (
        <div>
            <BasicCheckbox {...rest} error={error} />
            <ErrorMessage>
                {error && (
                    <Text type={FontTypes.Caption} color="error">
                        {errorMessage}
                    </Text>
                )}
            </ErrorMessage>
        </div>
    );
};
